module.exports = __webpack_public_path__ + "media/images/asterisk-white-75c9d508238d0aeac880bd704de1e0a0.svg";